import queryString from 'qs';

export const getAvailableHostRequest = (queryParams) => {
  const queries = {};

  if (queryParams?.brand) queries['brand'] = queryParams?.brand;
  if (queryParams?.search) queries['search'] = queryParams?.search;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getAvailableHostRequest;
